// Utility functions for input validations

// Regex
const emailRegex =
  /^[a-zA-Z0-9][a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,5}$/;
const indianMobileNumberRegex =
  /^(?:(?:\+91|91|0)[\s-]?)?(?!([6-9])\1{9})([6-9]\d{9})$/;
const cinRegex = /^[LU]\d{5}[A-Z]{2}\d{4}[A-Z]{3}\d{6}$/;
const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
const qualificationRegex = /^[A-Za-z&.\-\s]+$/;
const mobileRegex = /^(?:\+91[-\s]?|0)?(?!([6-9])\1{9})[6-9]\d{9}$/;
const aadharRegex = /^[2-9]\d{11}$/;
const ifscRegex = /^[A-Z]{4}0[A-Z0-9]{6}$/;

const panValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
  let { value } = e.target;

  // Remove any characters that aren't letters or digits
  value = value.replace(/[^a-zA-Z0-9]/g, "");

  // Ensure the first 5 characters are uppercase letters
  if (value.length <= 5) {
    value = value.toUpperCase().replace(/[^A-Z]/g, "");
  } else {
    const lettersPart = value
      .slice(0, 5)
      .toUpperCase()
      .replace(/[^A-Z]/g, "");
    let remainingValue = value.slice(5);

    // Ensure the next 4 characters are digits
    if (remainingValue.length > 0) {
      const digitsPart = remainingValue.slice(0, 4).replace(/\D/g, "");
      remainingValue = remainingValue.slice(4);

      if (remainingValue.length > 0) {
        const lastChar = remainingValue
          .charAt(0)
          .toUpperCase()
          .replace(/[^A-Z]/g, "");
        value = lettersPart + digitsPart + lastChar;
      } else {
        value = lettersPart + digitsPart;
      }
    } else {
      value = lettersPart;
    }
  }
  value = value.slice(0, 10);
  e.target.value = value;
};
const mobileValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
  let { value } = e.target;
  value = value.replace(/\D/g, "");
  value = value.slice(0, 10);
  if (value.length > 0 && !/^[6-9]/.test(value)) {
    value = value.slice(1);
  }
  e.target.value = value;
};

const uinValidation = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { value, selectionStart } = event.target;

  // Remove any characters that aren't letters or digits
  value.replace(/[^a-zA-Z0-9]/g, "").slice(0, 12);
  event.target.setSelectionRange(selectionStart, selectionStart);
};
const emailValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
  let inputValue = e.target.value;
  inputValue = inputValue.replace(/\s+/g, "");
  inputValue = inputValue.slice(0, 40);
  e.target.value = inputValue;
};

const capitalizeInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number
) => {
  const { value, selectionStart } = event.target;
  event.target.value = value.toUpperCase()?.slice(0, size);
  // adjust the cursor position
  event.target.setSelectionRange(selectionStart, selectionStart);
};

// validation to make first character to Capitalize
const firstLetterCapitalize = (
  event: React.ChangeEvent<HTMLInputElement>,
  size: number = 250
) => {
  const { value, selectionStart } = event.target;
  const inputValue = value.slice(0, size);
  // Capitalize the first letter of each word
  const capitalizedValue = inputValue.replace(/\b\w/g, (char) =>
    char.toUpperCase()
  );
  event.target.value = capitalizedValue;

  // Adjust the cursor position
  event.target.setSelectionRange(selectionStart, selectionStart);
};

// function that take input and size parament and add the number validation with size
// eg: onlyNumbers(event, 10) will allow only numbers and maximum 10 numbers
const onlyNumbers = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number
) => {
  const { value } = event.target;

  // Filter out non-numeric characters and limit to specified size
  const cleanedValue = value.replace(/[^0-9]/g, "").slice(0, size);
  event.target.value = cleanedValue;
};
const onlyNumbersWithComma = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number
) => {
  const { value } = event.target;

  // Keep only digits
  const numericValue = value.replace(/[^0-9]/g, "").slice(0, size);

  // Format as Indian Rupee style (commas in right places)
  const formattedValue = numericValue
    ? new Intl.NumberFormat("en-IN").format(Number(numericValue))
    : "";

  event.target.value = formattedValue;
};
const onlyNumbersWithoutLeadingZero = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number
) => {
  let { value } = event.target;

  // Remove non-numeric characters
  value = value.replace(/[^0-9]/g, "");

  // Prevent leading zero
  if (value.length > 0 && value[0] === "0") {
    value = value.replace(/^0+/, "");
  }

  // Enforce max size if provided
  if (size) {
    value = value.slice(0, size);
  }

  event.target.value = value;
};

// Modified this code if we want to take number like 786.12 then size = 6 and maxIntegerDigit = 3
const onlyNumbersAndDot = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number, // Maximum total size of the input
  maxIntegerDigits?: number // Maximum digits before the decimal point
) => {
  const { value } = event.target;

  // Allow only numbers and a single dot
  const newValue = value.replace(/[^0-9.]/g, "");

  // Split the value by the dot
  const parts = newValue.split(".");

  // Prevent more than one dot
  if (parts.length > 2) {
    event.target.value = value.slice(0, -1);
    return;
  }

  // Limit the integer part (before the dot) to maxIntegerDigits
  const integerPart = parts[0].slice(0, maxIntegerDigits);

  // Limit the decimal part (after the dot) to 2 digits
  const decimalPart = parts[1] ? parts[1].slice(0, 2) : "";

  // Rebuild the value with the integer part and decimal part if present
  let finalValue =
    parts.length === 2 ? `${integerPart}.${decimalPart}` : integerPart;

  // Apply the size limit (if provided)
  if (size) {
    finalValue = finalValue.slice(0, size);
  }

  event.target.value = finalValue;
};
const onlyNumbersAndDotwithDecimal = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number,
  maxIntegerDigits?: number,
  maxDecimalDigits: number = 3
) => {
  const { value } = event.target;

  // allow only digits and dot
  const newValue = value.replace(/[^0-9.]/g, "");

  const parts = newValue.split(".");

  // prevent more than one dot
  if (parts.length > 2) {
    event.target.value = value.slice(0, -1);
    return;
  }

  // integer part limit
  const integerPart = maxIntegerDigits
    ? parts[0].slice(0, maxIntegerDigits)
    : parts[0];

  // decimal part limit
  const decimalPart = parts[1] ? parts[1].slice(0, maxDecimalDigits) : "";

  let finalValue =
    parts.length === 2 ? `${integerPart}.${decimalPart}` : integerPart;

  // total size limit
  if (size) {
    finalValue = finalValue.slice(0, size);
  }

  event.target.value = finalValue;
};
const onlyNumbersAndDotWithoutRounding = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number, // Maximum total size of the input
  maxIntegerDigits?: number // Maximum digits before the decimal point
) => {
  let { value } = event.target;

  // Allow only numbers and a single dot
  value = value.replace(/[^0-9.]/g, "");

  // Split the value by the dot
  const parts = value.split(".");

  // Prevent more than one dot
  if (parts.length > 2) {
    value = parts[0] + "." + parts[1]; // Keep only first two parts
  }

  // Limit integer part length
  if (maxIntegerDigits && parts[0].length > maxIntegerDigits) {
    parts[0] = parts[0].slice(0, maxIntegerDigits);
    value = parts.join(".");
  }

  // Limit total length
  if (size && value.length > size) {
    value = value.slice(0, size);
  }

  event.target.value = value;
};
// validation that only allows characters to be entered
const onlyCharacters = (event: React.ChangeEvent<HTMLInputElement>) => {
  const { value, selectionStart } = event.target;
  event.target.value = value.replace(/[^a-zA-Z ]/g, "");
  // adjust the cursor position
  event.target.setSelectionRange(selectionStart, selectionStart);
};

const isValidCharAtPosition = (char: string, index: number): boolean => {
  // 0–1 → State code (digits)
  if (index <= 1) return /[0-9]/.test(char);
  // 2–6 → PAN letters
  if (index >= 2 && index <= 6) return /[A-Z]/.test(char);
  // 7–10 → PAN digits
  if (index >= 7 && index <= 10) return /[0-9]/.test(char);
  // 11 → PAN last letter
  if (index === 11) return /[A-Z]/.test(char);
  // 12 → Entity code (1–9 or A–Z)
  if (index === 12) return /[1-9A-Z]/.test(char);
  // 13 → Fixed Z
  if (index === 13) return char === "Z";
  // 14 → Checksum (alphanumeric)
  if (index === 14) return /[0-9A-Z]/.test(char);
  return false;
};

const gstValidation = (event: React.ChangeEvent<HTMLInputElement>) => {
  const value = event.target.value.toUpperCase();
  let validValue = "";
  for (let i = 0; i < value.length && i < 15; i++) {
    const char = value[i];
    if (isValidCharAtPosition(char, i)) {
      validValue += char;
    } else {
      break;
    }
  }
  event.target.value = validValue;
};

const onlyStdCode = (
  event: React.ChangeEvent<HTMLInputElement>,
  size: number = 5 // STD codes are usually 3–5 digits, including leading 0
) => {
  const { value } = event.target;

  // Keep only numbers, max length = `size`
  const cleanedValue = value.replace(/[^1-9]/g, "").slice(0, size);

  // Validate STD code format: starts with 0, followed by 2–4 digits
  const isValid = /^0[1-9][0-9]{1,3}$/.test(cleanedValue);

  // Optionally: only update value if it's partially valid (starts with 0)
  event.target.value = cleanedValue;

  // Optional: return validity if needed
  return isValid;
};

const onlyAlphabets = (
  event: React.ChangeEvent<HTMLInputElement>,
  len: number = 250
) => {
  let { value } = event.target;
  if (value.startsWith(" ")) {
    value = value.trimStart();
  }
  value = value.charAt(0).toUpperCase() + value.slice(1);
  value = value.replace(/[^a-zA-Z ]/g, "");
  value = value.replace(/\s{2,}/g, " ");
  value = value.slice(0, len);
  event.target.value = value;
};
const onlyAlphabetsAndNumbers = (
  event: React.ChangeEvent<HTMLInputElement>,
  len?: number
) => {
  let inputValue = event.target.value;

  inputValue = inputValue.replace(/[^a-zA-Z0-9]/g, "");

  // Replace multiple spaces with a single space
  inputValue = inputValue.replace(/\s{2,}/g, " ");

  // Trim start to avoid leading space
  inputValue = inputValue.replace(/^\s/, "");

  event.target.value = inputValue.slice(0, len);
};
const onlyAlphabetsNumbersAndSpace = (
  event: React.ChangeEvent<HTMLInputElement>,
  len?: number
) => {
  let inputValue = event.target.value;

  // Allow alphabets, numbers, and space
  inputValue = inputValue.replace(/[^a-zA-Z0-9 ]/g, "");

  // Replace multiple spaces with a single space
  inputValue = inputValue.replace(/\s{2,}/g, " ");

  // Trim start to avoid leading space
  inputValue = inputValue.replace(/^\s/, "");

  event.target.value = inputValue.slice(0, len);
};

const allowAllCharacters = (
  event: React.ChangeEvent<HTMLInputElement>,
  len?: number
) => {
  let inputValue = event.target.value;

  // Replace multiple spaces with a single space
  inputValue = inputValue.replace(/\s{2,}/g, " ");

  // Trim start to avoid leading space
  inputValue = inputValue.replace(/^\s/, "");

  event.target.value = len ? inputValue.slice(0, len) : inputValue;
};

const onlyAlphabetsAndDelimiters = (
  event: React.ChangeEvent<HTMLInputElement>,
  len?: number
) => {
  const inputValue = event.target.value;
  const finalValue = inputValue.replace(/[^a-zA-Z\-/]/g, "");
  event.target.value = finalValue.slice(0, len);
};

const onlyAlphabetsNumbersHypensAndSlash = (
  event: React.ChangeEvent<HTMLInputElement>,
  len: number = 35
) => {
  const inputValue = event.target.value;
  const finalValue = inputValue.replace(/[^a-zA-Z0-9\-\\/\\ ]/g, "");
  event.target.value = finalValue.slice(0, len);
};

const onlyAlphabetsNumbersAndDelimiters = (
  event: React.ChangeEvent<HTMLInputElement>,
  len?: number
) => {
  const inputValue = event.target.value;
  // Allow A-Z, a-z, 0-9, hyphen (-), slash (/)
  const finalValue = inputValue.replace(/[^a-zA-Z0-9\-(),?'"\s]/g, "");
  // limit max length
  event.target.value = finalValue.slice(0, len);
};

const onlyPasswordInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength: number = 25
) => {
  let value = event.target.value;

  // Remove spaces
  value = value.replace(/\s+/g, "");

  // Allow letters, numbers, and special characters
  value = value.replace(/[^a-zA-Z0-9!@#$%^&*()_+\-=[\]{};':",.<>/?]/g, "");

  // Apply max length
  event.target.value = value.slice(0, maxLength);
};

const ifscValidation = (event: React.ChangeEvent<HTMLInputElement>) => {
  const inputValue = event.target.value.toUpperCase();
  let setValue = "";

  if (/^[A-Z]{0,4}$/.test(inputValue)) {
    setValue = inputValue;
  } else if (/^[A-Z]{4}[0-9]{0,7}$/.test(inputValue)) {
    setValue =
      inputValue.slice(0, 4) +
      inputValue.slice(4, 11).replace(/\W/g, "").toUpperCase();
  } else {
    event.target.value = "";
    return;
  }

  event.target.value = setValue;
};
const allowHyphenOnlyValidation = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  let inputValue = event.target.value;
  inputValue = inputValue.replace(/[^a-z-]/g, "");
  const finalValue = inputValue.slice(0, 15);
  event.target.value = finalValue;
};

const allowUnderscoreOnlyValidation = (
  event: React.ChangeEvent<HTMLInputElement>
) => {
  const { value, selectionStart } = event.target;
  // Remove any character that is not a lowercase letter or underscore
  const newValue = value.replace(/[^a-z_]/g, "");
  if (value !== newValue) {
    event.target.value = newValue;
    const newSelectionStart = selectionStart !== null ? selectionStart - 1 : 0;
    event.target.setSelectionRange(newSelectionStart, newSelectionStart);
  }
};

const allowUnderscoreOnlyValidationwithLength = (
  event: React.ChangeEvent<HTMLInputElement>,
  size: number = 250
) => {
  const { value, selectionStart } = event.target;

  // Apply max length
  const trimmedValue = value.slice(0, size);

  // Allow only lowercase letters + underscore
  const newValue = trimmedValue.replace(/[^a-z_]/g, "");

  if (value !== newValue) {
    event.target.value = newValue;

    const newSelectionStart = selectionStart !== null ? selectionStart - 1 : 0;

    event.target.setSelectionRange(newSelectionStart, newSelectionStart);
  } else {
    event.target.value = newValue;
  }
};

const allowUnderscoreNumAlphaValidation = (
  event: React.ChangeEvent<HTMLInputElement>,
  size: number = 250
) => {
  const { value, selectionStart } = event.target;
  const inputValue = value.slice(0, size);

  // Remove any character that is not a lowercase letter or underscore
  const newValue = inputValue.replace(/[^a-z0-9_]/g, "");
  if (inputValue !== newValue) {
    event.target.value = newValue;
    const newSelectionStart = selectionStart !== null ? selectionStart - 1 : 0;
    event.target.setSelectionRange(newSelectionStart, newSelectionStart);
  }
  event.target.value = newValue;
};

const allowAmpersandNumAlphaValidation = (
  event: React.ChangeEvent<HTMLInputElement>,
  size: number = 250
) => {
  const { value, selectionStart } = event.target;
  const inputValue = value.slice(0, size);

  // Remove any character that is not a lowercase letter or underscore
  const newValue = inputValue.replace(/[^a-zA-Z0-9& ]/g, "");
  if (inputValue !== newValue) {
    event.target.value = newValue;
    const newSelectionStart = selectionStart !== null ? selectionStart - 1 : 0;
    event.target.setSelectionRange(newSelectionStart, newSelectionStart);
  }
  event.target.value = newValue;
};
const allowSpaceAmpersandNumAlphaValidation = (
  event: React.ChangeEvent<HTMLInputElement>,
  size: number = 250
) => {
  const { value, selectionStart } = event.target;

  // Allow letters, numbers, ampersand, and single spaces; block leading spaces
  const newValue = value
    .slice(0, size)
    .replace(/[^a-zA-Z0-9& ]/g, "") // Remove invalid characters
    .replace(/^\s+/g, "") // Block leading spaces
    .replace(/\s{2,}/g, " "); // Replace multiple spaces with a single space

  if (value !== newValue) {
    event.target.value = newValue;
    const cursorPosition =
      selectionStart !== null
        ? Math.max(0, selectionStart - (value.length - newValue.length))
        : 0;
    event.target.setSelectionRange(cursorPosition, cursorPosition);
  }
};

const imoValidation = (e: React.ChangeEvent<HTMLInputElement>) => {
  let { value } = e.target;

  // Remove any characters that aren't letters or digits
  value = value.replace(/[^a-zA-Z0-9]/g, "");

  // Ensure the first 3 characters are uppercase letters
  if (value.length <= 3) {
    value = value.toUpperCase().replace(/[^A-Z]/g, "");
  } else {
    const lettersPart = value
      .slice(0, 3)
      .toUpperCase()
      .replace(/[^A-Z]/g, "");
    const remainingValue = value.slice(3);

    // Ensure the next 7 characters are digits
    const digitsPart = remainingValue.slice(0, 7).replace(/\D/g, "");

    value = lettersPart + digitsPart;
  }

  // Restrict to the first 10 characters
  value = value.slice(0, 10);
  e.target.value = value;
};

const onlyNumbersAndSpecialCharacters = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number
) => {
  const { value } = event.target;

  // Regular expression to match anything that is not a letter (a-z, A-Z)
  event.target.value = value.replace(/[a-zA-Z]/g, "").slice(0, size ?? 3);
};
const preventConsecutiveZeros = (
  event: React.ChangeEvent<HTMLInputElement>,
  limit: number = 5
) => {
  const inputValue = event.target.value;

  const regex = new RegExp(`0{${limit + 1},}`, "g");
  event.target.value = inputValue.replace(regex, "0".repeat(limit));
};

const onlyTwoDigitFloats = (
  event: React.ChangeEvent<HTMLInputElement>,
  size?: number
) => {
  let { value } = event.target;

  // Remove invalid characters
  value = value.replace(/[^0-9.]/g, "");

  // Prevent multiple dots
  const dotCount = (value.match(/\./g) || []).length;
  if (dotCount > 1) {
    value = value.replace(/\./g, (_, offset) =>
      offset === value.indexOf(".") ? "." : ""
    );
  }

  // Handle decimal numbers
  if (value.includes(".")) {
    const [integerPart, decimalPart] = value.split(".");

    // Restrict dot placement based on integer part length
    if (integerPart.length > 2) {
      value = integerPart.slice(0, 3); // Disallow the dot if integer part exceeds 2 digits
    } else {
      // Allow integer + decimal based on integer length
      value = `${integerPart.slice(0, 2)}.${decimalPart.slice(0, 2)}`;
    }
  }

  // Restrict total size
  if (!value.includes(".") && size) {
    value = value.slice(0, size); // Allow only up to the specified size for integers
  }

  const numericValue = parseFloat(value);
  if (numericValue > 100) {
    value = value.slice(0, 2);
  }

  // Update the input's value
  event.target.value = value;
};

const validateAddressInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  len: number = 50
) => {
  const inputValue = event.target.value;
  const finalValue = inputValue.replace(/[^a-zA-Z0-9 @$&*]/g, "");
  event.target.value = finalValue.slice(0, len);
};
const formatAmountWithIndianCommas = (
  e: React.ChangeEvent<HTMLInputElement>,
  size?: number
): void => {
  // Remove commas and non-digit characters
  let value = e.target.value.replace(/,/g, "").replace(/\D/g, "");

  // Apply digit limit BEFORE formatting
  if (size) {
    value = value.slice(0, size);
  }

  if (!value) {
    e.target.value = "";
    return;
  }

  // Format using Indian numbering system
  let lastThree = value.substring(value.length - 3);
  const otherNumbers = value.substring(0, value.length - 3);

  if (otherNumbers !== "") {
    lastThree = "," + lastThree;
  }

  const formatted =
    otherNumbers.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThree;

  e.target.value = formatted;
};

const handleGlobalTextValidation =
  (
    setter: React.Dispatch<React.SetStateAction<string>>,
    maxLength: number = 20
  ) =>
  (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target;
    const cursorPosition = input.selectionStart ?? 0;
    const value = (event as any).value ?? input.value;

    // Count characters before cursor
    const beforeCursor = value.substring(0, cursorPosition);

    // Transform input: only letters and spaces, remove leading spaces, limit length
    const transformedValue = value
      .replace(/[^a-zA-Z\s]/g, "") // letters only
      .replace(/\s+/g, " ") // remove multiple spaces
      .trimStart() // remove leading spaces
      .slice(0, maxLength); // limit length

    // Set the state
    setter(transformedValue);

    // Adjust cursor
    requestAnimationFrame(() => {
      if (input) {
        const transformedBeforeCursor = beforeCursor
          .replace(/[^a-zA-Z\s]/g, "")
          .replace(/\s+/g, " ")
          .trimStart(); // remove leading spaces for cursor calculation

        const newCursorPosition = Math.min(
          transformedBeforeCursor.length,
          transformedValue.length
        );
        input.setSelectionRange(newCursorPosition, newCursorPosition);
      }
    });
  };

const handleNameInputByEvent =
  (maxLength: number = 25) =>
  (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target;

    const cursor = input.selectionStart ?? 0;
    const rawValue = input.value;

    // Text before cursor (important!)
    const beforeCursor = rawValue.slice(0, cursor);

    const capitalizeWords = (value: string) =>
      value.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase());

    // ---- transform FULL value ----
    let transformedValue = rawValue
      .replace(/[^a-zA-Z\s]/g, "") // letters + space
      .replace(/\s+/g, " ") // no multiple spaces
      .trimStart() // no leading space
      .slice(0, maxLength);
    transformedValue = capitalizeWords(transformedValue);
    // ---- transform value BEFORE cursor ----
    let transformedBeforeCursor = beforeCursor
      .replace(/[^a-zA-Z\s]/g, "")
      .replace(/\s+/g, " ")
      .trimStart();
    transformedBeforeCursor = capitalizeWords(transformedBeforeCursor);
    // Update input value
    input.value = transformedValue;

    // Restore cursor correctly
    requestAnimationFrame(() => {
      const newCursor = Math.min(
        transformedBeforeCursor.length,
        transformedValue.length
      );
      input.setSelectionRange(newCursor, newCursor);
    });
  };

const handleAadhaarInput = (e: React.ChangeEvent<HTMLInputElement>) => {
  const input = e.target;
  const rawValue = input.value;
  const cursor = input.selectionStart ?? 0;

  // Count digits BEFORE cursor
  const digitsBeforeCursor = rawValue
    .slice(0, cursor)
    .replace(/\D/g, "").length;

  // Store this for later use
  input.dataset.digitsBeforeCursor = digitsBeforeCursor.toString();
};

const validatePassword = (value: string) => {
  if (!/^.{8,}$/.test(value)) return "Must be at least 8 characters long.";
  if (!/[A-Z]/.test(value))
    return "Must contain at least one uppercase letter (A-Z).";
  if (!/[a-z]/.test(value))
    return "Must contain at least one lowercase letter (a-z).";
  if (!/\d/.test(value)) return "Must contain at least one digit (0-9).";
  if (!/[!@#$%^&*()_+\-=[\]{};':",.<>/?]/.test(value))
    return "Must contain at least one special character (!@#$%^&*()_+-=[]{};':\",.<>/?).";
  if (/\s/.test(value)) return "No spaces allowed.";
  return true;
};

const validateCode = (value: string) => {
  const regex = /^[A-Z0-9]{3,12}$/;

  if (!regex.test(value)) {
    if (/\s/.test(value)) return "No spaces allowed.";
    if (/[^A-Z0-9]/.test(value))
      return "Only uppercase letters (A-Z) and digits (0-9) are allowed.";
    if (value.length < 3 || value.length > 12)
      return "Must be between 3 and 12 characters long.";
    return "Invalid format.";
  }

  return true;
};

const validatename = (value: string) => {
  if (!/^[A-Za-z ]+$/.test(value)) return "Only alphabets are allowed";
  // if (value.length < 3 || value.length > 12)
  //   return "Must be between 3 and 12 characters long.";
};

const sanitizeMasterPolicyInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength: number = 20
) => {
  let value = event.target.value;

  // 1. Remove all spaces
  value = value.replace(/\s+/g, "");

  // 2. Convert to UPPERCASE always
  value = value.toUpperCase();

  // 3. Remove all characters except A–Z, digits, "-" and "/"
  value = value.replace(/[^A-Z0-9/-]/g, "");

  // 4. Split into blocks by "-" or "/"
  const parts = value.split(/[-/]/);

  // Handle prefix (2–4 uppercase letters)
  if (parts[0]) {
    parts[0] = parts[0].replace(/[^A-Z]/g, "").slice(0, 4);
  }

  // Handle number block (5–10 digits)
  if (parts[1]) {
    parts[1] = parts[1].replace(/\D/g, "").slice(0, 10);
  }

  // Handle year block (2 digits, allowed 22–30)
  if (parts[2]) {
    parts[2] = parts[2].replace(/\D/g, "").slice(0, 2);
    if (parts[2].length === 2) {
      const year = Number(parts[2]);
      if (year < 22 || year > 30) {
        parts[2] = ""; // clear invalid year
      }
    }
  }

  // 5. Rebuild with original typed separators
  const seps = value.match(/[-/]/g) || [];
  let finalValue = parts[0] || "";

  if (parts[1] !== undefined) finalValue += (seps[0] || "") + parts[1];

  if (parts[2] !== undefined) finalValue += (seps[1] || "") + parts[2];

  // 6. Enforce total max length 20
  finalValue = finalValue.slice(0, maxLength);

  // Set sanitized value back into the field
  event.target.value = finalValue;
};
const validateNameInput = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength = 70
) => {
  let value = event.target.value;

  // Allow only alphabets, dots and spaces
  value = value.replace(/[^a-zA-Z. ]/g, "");

  // Replace multiple spaces with a single space
  value = value.replace(/\s+/g, " ");

  // Limit length
  value = value.slice(0, maxLength);

  event.target.value = value;

  return value;
};
const branchCodeRegex = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength: number = 40 // increased to allow 28 letters + "-" + numbers
) => {
  let value = event.target.value;

  // 1. Remove spaces
  value = value.replace(/\s+/g, "");

  // 2. Always uppercase
  value = value.toUpperCase();

  // 3. Allow only A–Z, digits, and "-"
  value = value.replace(/[^A-Z0-9-]/g, "");

  // 4. Split CITY and NUMBER
  const parts = value.split("-");

  // ----- CITY BLOCK -----
  if (parts[0]) {
    // Only alphabets, max 28 chars
    parts[0] = parts[0].replace(/[^A-Z]/g, "").slice(0, 28);
  }

  // ----- NUMBER BLOCK -----
  if (parts[1]) {
    // Only digits, max 100 digits allowed
    parts[1] = parts[1].replace(/\D/g, "").slice(0, 100);
  }

  // 5. Rebuild final value using original separator
  const sep = value.includes("-") ? "-" : "";
  let finalValue = parts[0] || "";

  if (parts.length > 1) {
    finalValue += sep + (parts[1] || "");
  }

  // 6. Final max length safety cap
  finalValue = finalValue.slice(0, maxLength);

  // Update field
  event.target.value = finalValue;
};

const onlyCurrencySymbol = (
  event: React.ChangeEvent<HTMLInputElement>,
  len: number = 3
) => {
  let { value } = event.target;

  // Remove leading spaces
  if (value.startsWith(" ")) {
    value = value.trimStart();
  }
  // Allow only currency symbols
  value = value.replace(/[^₹$€£¥₩₦฿₫₪₱₴₲₵₸₺₼₽₿₡₠₢₣₤₥₦₧₨₩]/g, "");

  // Prevent repeated same symbols (optional)
  value = [...new Set(value)].join("");

  // Limit length
  value = value.slice(0, len);

  event.target.value = value;
};
const stripHtmlTagsFromInput = (e: React.ChangeEvent<HTMLInputElement>) => {
  const value = e.target.value;

  // Remove HTML tags but keep allowed characters as text
  const sanitizedValue = value.replace(/<\/?[^>]+(>|$)/g, "");

  if (sanitizedValue !== value) {
    e.target.value = sanitizedValue;
  }
};
const allowAlphaNumAndSpecial = (
  event: React.ChangeEvent<HTMLInputElement>,
  maxLength: number = 100
) => {
  let value = event.target.value;
  value = value.match(/[a-zA-Z0-9!&():?_/",.\s+-]/g)?.join("") || "";
  value = value.slice(0, maxLength);
  event.target.value = value;
};
function preventSpacesOnInput(event: React.ChangeEvent<HTMLInputElement>) {
  event.target.value = event.target.value.replace(/\s/g, "");
}
export const inputUtility = {
  preventSpacesOnInput,
  handleNameInputByEvent,
  handleAadhaarInput,
  onlyCurrencySymbol,
  onlyPasswordInput,
  onlyAlphabetsAndDelimiters,
  validatename,
  validateCode,
  validatePassword,
  mobileRegex,
  qualificationRegex,
  preventConsecutiveZeros,
  capitalizeInput,
  onlyNumbers,
  onlyCharacters,
  firstLetterCapitalize,
  gstValidation,
  panValidation,
  uinValidation,
  ifscValidation,
  mobileValidation,
  allowHyphenOnlyValidation: allowHyphenOnlyValidation,
  allowUnderscoreOnlyValidation,
  onlyAlphabets,
  onlyAlphabetsAndNumbers,
  allowUnderscoreNumAlphaValidation,
  allowAmpersandNumAlphaValidation,
  onlyNumbersAndDot,
  onlyNumbersWithComma,
  emailRegex,
  indianMobileNumberRegex,
  emailValidation,
  imoValidation,
  onlyNumbersAndSpecialCharacters,
  onlyTwoDigitFloats,
  allowSpaceAmpersandNumAlphaValidation,
  validateAddressInput,
  formatAmountWithIndianCommas,
  cinRegex,
  gstRegex,
  onlyStdCode,
  onlyNumbersAndDotWithoutRounding,
  handleGlobalTextValidation,
  onlyAlphabetsNumbersAndSpace,
  onlyAlphabetsNumbersAndDelimiters,
  sanitizeMasterPolicyInput,
  branchCodeRegex,
  onlyAlphabetsNumbersHypensAndSlash,
  onlyNumbersWithoutLeadingZero,
  onlyNumbersAndDotwithDecimal,
  allowAllCharacters,
  allowUnderscoreOnlyValidationwithLength,
  stripHtmlTagsFromInput,
  aadharRegex,
  ifscRegex,
  allowAlphaNumAndSpecial,
  validateNameInput
};
